<template>
  <Frame>
    <PageHeader :title="$t('salSalesOrder.shipmentApply')" :hasBack="true" />
    <el-table ref="singleTable" :data="tableData" :max-height="tableHeight"
      style="margin:0;width:100%;margin-bottom: 20px;" v-loading="tableLoading" highlight-current-row
      @current-change="handleCurrentChange">
      <el-table-column type="index" width="50" :label="$t('orderImport.rowNo')"></el-table-column>
      <el-table-column :width="110" :label="$t('salSalesOrder.urgentLeave')">
        <template scope="scope">
          <el-select size="small" v-model="scope.row.X_UrgentLeave">
            <el-option v-for="item in urgentTypeList" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :width="110" :label="$t('salSalesOrder.isPartShipment')">
        <template scope="scope">
          <el-select size="small" v-model="scope.row.X_IsPartShipment">
            <el-option v-for="item in yesNoList" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :min-width="200" prop="X_OperaExplain" :label="$t('salSalesOrder.operaExplain')">
        <template scope="scope">
          <el-input type="textarea" :rows="2" :placeholder="$t('salSalesOrder.inputpls')" maxlength="200"
            v-model="scope.row.X_OperaExplain"></el-input>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo"
        :label="$t('salSalesOrder.orderNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_CustNumberOrg', tableData)" prop="X_CustNumberOrg"
        :label="$t('salSalesOrder.customerNo2')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialSpec', tableData)" prop="X_BPMaterialSpec"
        show-overflow-tooltip :label="$t('salSalesOrder.meterialSpe')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_TotalSQty', tableData)" prop="X_TotalSQty" align="right"
        :label="$t('salSalesOrder.sQty')"></el-table-column>
      <el-table-column :min-width="WidthControl('BillDate', tableData)" prop="BillDate"
        :label="$t('salSalesOrderDetail.messagedate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_NewDate', tableData)" prop="X_NewDate"
        :label="$t('salSalesOrder.newDate2')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_SupId', tableData)" prop="X_SupId"
        :label="$t('salSalesOrder.supplier')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_UrgentTypeName', tableData)" prop="X_UrgentTypeName"
        :label="$t('salSalesOrder.urgentTypeName')"></el-table-column>
    </el-table>
    <el-table :data="subtableData" :height="230" style="margin:0;width:100%" v-loading="tableLoading">
      <el-table-column type="index" width="50" :label="$t('orderImport.rowNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('PersonName', tableData)" :label="$t('salSalesOrder.personId')">
        <template slot-scope="scope">
          <span>{{ scope.row.PersonId?scope.row.PersonId+",&nbsp":'' }}{{ scope.row.PersonName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('BizPartnerId&&BizPartnerName', tableData)"
        :label="$t('salSalesOrder.BizPartnerId')">
        <template slot-scope="scope">
          <span>{{ scope.row.BizPartnerId?scope.row.BizPartnerId+",&nbsp":'' }}{{ scope.row.BizPartnerName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('ShortName', tableData)" prop="ShortName"
        :label="$t('salSalesOrder.shortName')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_CustNumberOrg', tableData)" prop="X_CustNumberOrg"
        :label="$t('salSalesOrder.customerNo2')"></el-table-column>
      <el-table-column :min-width="WidthControl('OrgId&&OrgName', tableData)" prop="OrgId"
        :label="$t('salSalesOrder.orgId')">
        <template slot-scope="scope">
          <span>{{ scope.row.OrgId?scope.row.OrgId+",&nbsp":'' }}{{ scope.row.OrgName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo"
        :label="$t('salSalesOrder.orderNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_Or', tableData)" prop="X_Or"
        :label="$t('salSalesOrder.X_Or')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialId', tableData)" prop="X_BPMaterialId"
        label="ItemCode"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialName', tableData)" prop="X_BPMaterialName"
        label="ItemName"></el-table-column>
      <el-table-column :min-width="WidthControl('TotalQty', tableData)" prop="TotalQty" align="right"
        :label="$t('salSalesOrder.sQty')"></el-table-column>
      <el-table-column :min-width="WidthControl('SUnitName', tableData)" :label="$t('salSalesOrder.sUnitId')">
        <template slot-scope="scope">
          <span>{{ scope.row.SUnitId?scope.row.SUnitId+",&nbsp":'' }}{{ scope.row.SUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('X_Length', tableData)" prop="X_Length"
        :label="$t('orderImport.lengthLable')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_LUnitName', tableData)" :label="$t('orderImport.lengthUnit')">
        <template slot-scope="scope">
          <span>{{ scope.row.X_LUnitId?scope.row.X_LUnitId+",&nbsp":'' }}{{ scope.row.X_LUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('X_ColorName', tableData)" :label="$t('orderImport.colorLable')">
        <template slot-scope="scope">
          <span>{{ scope.row.X_ColorId?scope.row.X_ColorId+",&nbsp":'' }}{{ scope.row.X_ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('BatchNo', tableData)" prop="BatchNo"
        :label="$t('salSalesOrder.batchNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_YKKStatus_En', tableData)" prop="X_YKKStatus_En"
        :label="$t('salSalesOrder.YKKStatus_En')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_YKKStatus', tableData)" prop="X_YKKStatus"
        :label="$t('salSalesOrder.YKKStatus')"></el-table-column>
    </el-table>

    <div class="footer-contain">
      <div class="btnarray">
        <el-button type="primary" @click="commit" :disabled="tableLoading" :title="$t('salSalesOrder.commitBtn')">{{
    $t('salSalesOrder.commitBtn')
          }}</el-button>
      </div>
    </div>
  </Frame>
</template>

<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { handleShortDate } from "@/utils/handleDate";
export default {
  name: "ShipmentApply",
  mixins: [listMixin],
  data() {
    return {
      tableHeight: window.innerHeight - 450,
      BillNos: "",
      urgentTypeList: [
        { value: 0, label: " " },
        { value: 1, label: this.$t("salSalesOrder.urgentLevel0") },
        { value: 2, label: this.$t("salSalesOrder.urgentLevel1") },
        { value: 3, label: this.$t("salSalesOrder.urgentLevel2") }
      ],
      yesNoList: [
        { value: 0, label: this.$t("comm.btnno") },
        { value: 1, label: this.$t("comm.btnyes") }
      ],
      subtableData: []
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function (...arg) {
        this.getListData(...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(200);
  },
  created() {
    this.BillNos = this.$route.query.BillNos;
    this.getListData();
  },
  methods: {
    getListData() {
      this.tableLoading = true;
      this.axiosInvoke(
        this.sysHandlerUrl,
        {
          action: "getsalsalesorder",
          BillNos: this.BillNos,
          pageIndex: 0,
          pageSize: 10
        },
        res => {
          const data = res.data;
          this.tableLoading = false;
          data.DataTable.forEach(element => {
            element.X_UrgentLeave = 1;
            element.X_IsPartShipment = 1;
            element.X_OperaExplain = '';
            element.X_CarryingType = '';
            element.X_UrgentShipDate = handleShortDate(new Date());
            switch (element.X_UrgentType) {
              case "1":
                element.X_UrgentTypeName = this.$t("salSalesOrder.urgentLevel0");
                break
              case "2":
                element.X_UrgentTypeName = this.$t("salSalesOrder.urgentLevel1");
                break
              case "3":
                element.X_UrgentTypeName = this.$t("salSalesOrder.urgentLevel2");
                break
            }
          });
          this.tableData = data.DataTable;
          this.$refs.singleTable.setCurrentRow(this.tableData[0]);
        },
        false,
        true
      );
    },
    commit() {
      this.tableLoading = true;
      this.axiosInvoke(
        this.sysHandlerUrl,
        {
          action: 'doshipmentapply',
          ymAy: JSON.stringify(this.tableData)
        },
        res => {
          const data = res.data[0];
          this.tableLoading = false;

          if (data.state == 0) {
            this.$store.commit("TIPPOP", { popType: 'error', popMessage: data.message });
          } else {
            this.$alert(data.message, this.$t("comm.tipContent"), {
              confirmButtonText: this.$t("comm.confirm"),
              callback: action => {
                this.$router.back();
              }
            });
          }
        },
        false,
        true
      );
    },
    handleCurrentChange(val) {
      this.tableLoading = true;
      this.axiosInvoke(
        this.sysHandlerUrl,
        {
          action: "getsaleorderdetail",
          salBillNo: val.BillNo
        },
        res => {
          const data = res.data;
          this.tableLoading = false;
          this.subtableData = data;
        },
        false,
        true
      );
    }
  }
};
</script>
<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}

.footer-contain {
  display: flex;
  padding-top: 6px;
  justify-content: center;
}

.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}

.el-table /deep/ thead {
  font-size: 14px;
  color: #5d5d5d;
}

.btnarray {
  margin-left: 7px;
}
</style>
